module.exports = __webpack_public_path__ + "img/dineOut_0318_1.2e4e91a5.png";